var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"type":"email","autocomplete":"email","placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"focus":function($event){return _vm.$emit('focus')},"blur":function($event){return _vm.$emit('blur')},"input":function (event) {
      _vm.$emit('changedValue', event.target.value);
    }}})}
var staticRenderFns = []

export { render, staticRenderFns }